import { savePremiumDetection } from "../data";
import { AdBlockerType } from "../types";
import { PremiumDetectionResult, sendEvent } from "../utils";

export const onPremiumUserDetected = (
  detectionResult: PremiumDetectionResult,
  detectedExtension: AdBlockerType,
) => {
  savePremiumDetection(detectionResult);
  sendEvent({
    event: "flattr",
    detectedExtension,
  }).catch(() => null);
};
